import React, { useEffect, useState } from "react";
import { Prompt } from "react-router-dom";
import { TextField, Switch, Box, Grid, Backdrop, Checkbox, Button } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles, Theme } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import { useFormik } from "formik";
import { object, string } from "yup";
import { useAppDispatch } from "src/app-redux/hooks";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { IVehicleType } from "src/common/typings/vehicle";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonAutoCompleteField from "../../../../../../components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "../../../../../../components/CommonButton/CommonButton";
import { columns } from "./columns";
import { setisDirtyValue } from "src/app-redux/configuration/configurationSlice";
import BoxesPileYellow from "src/assets/images/icons_status/boxes-pile-yellow.png";
import CheckGreen from "src/assets/images/icons_status/check-green.png";
import ChecklistBlue from "src/assets/images/icons_status/checklist-blue.png";
import CircleBlue from "src/assets/images/icons_status/circle-blue.png";
import CrossRed from "src/assets/images/icons_status/cross-red.png";
import DotsGrey from "src/assets/images/icons_status/dots-grey.png";
import ExclamationOrange from "src/assets/images/icons_status/exclamation-orange.png";
import InactiveStateGrey from "src/assets/images/icons_status/inactive-state-grey.png";
import NegativeOrange from "src/assets/images/icons_status/negative-orange.png";
import SearchPink from "src/assets/images/icons_status/search-pink.png";
import TruckBanGrey from "src/assets/images/icons_status/truck-ban-grey.png";
import TruckWeightGreen from "src/assets/images/icons_status/truck-weight-green.png";
import { Check, Close } from "@material-ui/icons";
import { Tooltip } from "@mui/material";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  formRow: {
    marginBottom: "0px",
    // borderBottom: "1px solid rgb(0 0 0 / 6%)",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  tabCardContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "auto",
    // boxShadow: "none",
    // borderRadius: "5px",
  },

  UserMainPanel: {
    width: "100%",
    float: "left",
    padding: "0px 20px",
    paddingRight: 0,
  },
  mainConainer: { marginTop: "0px" },
}));

export interface IForm extends IVehicleType {}

interface Props {
  // In TS we make an interface of Props to shape them.
  handleSubmit: (formData: IForm) => Promise<void>;
  updateSubmit: (formData: IForm) => Promise<void>;
  initialValues?: IVehicleType; // '?' Its means initialValues is Optional
  loading?: any;
  tableRecord?: any;
  temp?: any;
}

export function InputFields({
  initialValues,
  handleSubmit,
  updateSubmit,
  loading,
  tableRecord,
}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [isEditMode, setisEditMode] = React.useState(false);
  const [submitCounter, setSubmitCounter] = useState<any>(0);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const allIcons: any = [
    { iconId: "1.", name: "boxes-pile-yellow", icon: BoxesPileYellow },
    { iconId: "2.", name: "check-green", icon: CheckGreen },
    { iconId: "3.", name: "checklist-blue", icon: ChecklistBlue },
    { iconId: "4.", name: "circle-blue", icon: CircleBlue },
    { iconId: "5.", name: "cross-red", icon: CrossRed },
    { iconId: "6.", name: "dots-grey", icon: DotsGrey },
    { iconId: "7.", name: "exclamation-orange", icon: ExclamationOrange },
    { iconId: "8.", name: "inactive-state-grey", icon: InactiveStateGrey },
    { iconId: "9.", name: "negative-orange", icon: NegativeOrange },
    { iconId: "10.", name: "search-pink", icon: SearchPink },
    { iconId: "11.", name: "truck-ban-grey", icon: TruckBanGrey },
    { iconId: "12.", name: "truck-weight-green", icon: TruckWeightGreen },
  ];

  const validationSchema = object({
    name: string().required("This field is required").max(50, "Maximum 50 characters are allowed."),
    icon: string().required("This field is required"),
  });
  const formik = useFormik<IForm>({
    enableReinitialize: true,
    initialValues: {
      id: initialValues?.id || 0,
      name: initialValues?.name || "",
      icon: initialValues?.icon || "",
      isOutOfWareHouse: initialValues?.isOutOfWareHouse || Boolean(false),
      isActive: initialValues?.isActive || Boolean(false),
    },
    validationSchema: validationSchema,
    // onSubmit: handleSubmit,
    onSubmit: (values, actions) => {
      if (isEditMode === false && isDuplicatedRecordInTable(tableRecord, values.name) !== -1) {
        dispatch(
          addNotificationAction({
            message: "Record already exist.",
            options: { variant: "error" },
          })
        );
        return;
      }
      if (isEditMode) updateSubmit(values);
      else {
        formik.setFieldValue("id", 0);
        handleSubmit(values);
      }
      actions.setSubmitting(false);
      actions.resetForm();
      setisEditMode(false);
      setIsDirtyValue(false);
      setSelectedRecord(null);
    },
  });
  const isDuplicatedRecordInTable = (array: any, value: any) => {
    // -1 if not found
    return array.findIndex((i: any) => i.name === value);
  };
  const handleUpdateClick = (params: any) => {
    setSelectedRecord(params);
    formik.setFieldValue("name", params.name);
    formik.setFieldValue("icon", params.icon);
    formik.setFieldValue("id", params.id);
    formik.setFieldValue("isOutOfWareHouse", params.isOutOfWareHouse);
    formik.setFieldValue("isActive", params.isActive);
    setisEditMode(true);
  };

  useEffect(() => {
    if (submitCounter) formik.submitForm();
  }, [submitCounter]);

  /* GRID Code */
  useEffect(() => {
    if (tableRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "actions"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        setIsDirtyValue(true);
                        handleUpdateClick(row.original);
                      }}
                      icon={<EditIcon />}
                      isEdit={true}
                    >
                      Edit
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column.accessorKey === "icon"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    {row.original.icon ? (
                      <img
                        src={allIcons.find((obj: any) => obj.name === row.original.icon)?.icon}
                        alt={allIcons.find((obj: any) => obj.name === row.original.icon)?.name}
                        style={{ marginLeft: "20%" }}
                      />
                    ) : (
                      <span style={{ marginLeft: "35%" }}>-</span>
                    )}
                  </>
                );
              },
            }
          : column.accessorKey === "isActive"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isActive ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isActive ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column.accessorKey === "isOutOfWareHouse"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.isOutOfWareHouse ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.isOutOfWareHouse ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [tableRecord]);

  // Show prompt if the form is fully or partially filled and user wants to navigate away
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    // If prompt, when reloading or closing the tab
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  function handleValueChange(e: any) {
    // Textfield ==>> e.target.value
    // Checkbox / Switch ==>> e.target.checked !== e.target._wrapperState.initialChecked

    formik.handleChange(e);
    e.target.value ? setIsDirtyValue(true) : setIsDirtyValue(false);
  }

  function setIsDirtyValue(val: boolean) {
    setIsDirty(val);
    dispatch(setisDirtyValue(val));
  }

  return (
    <>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <form onSubmit={formik.handleSubmit}>
        <Backdrop className={classes.backdrop} open={loading}>
          <CommonLoader />
        </Backdrop>
        <Grid container direction="row" alignItems="flex-start">
          {/* First Section */}
          <>
            <Grid className={classes.UserMainPanel}>
              <Grid
                // Container
                container
                className={classes.mainConainer}
                direction="row"
                alignItems="center"
                spacing={2}
              >
                <Grid container item xs={12} md={12} lg={9} spacing={2}>
                  <Grid item xs={6} md={3} style={{ paddingLeft: "0px" }}>
                    <Box>
                      {allIcons.find((st: any) => st.name === formik.values.icon) ? (
                        <div
                          style={{
                            position: "relative",
                            zIndex: 1,
                            width: "12px",
                            height: "12px",
                            margin: "9px 31px -20px",
                          }}
                        >
                          <img
                            src={allIcons.find((st: any) => st.name === formik.values.icon).icon}
                            alt={allIcons.find((st: any) => st.name === formik.values.icon).name}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      <div>
                        <CommonAutoCompleteField
                          cssClassName="customTextField"
                          placeholder="Add Icon"
                          label="Icon No"
                          name="icon"
                          optionsType={allIcons}
                          getOptionLabel={(option) => option.iconId}
                          renderOption={(option) => (
                            <>
                              <Grid container direction="row">
                                <Grid item md={6} lg={6}>
                                  {option.iconId}
                                </Grid>
                                <Grid item md={6} lg={6}>
                                  <img src={option.icon} alt={option.name} />
                                </Grid>
                              </Grid>
                            </>
                          )}
                          required
                          value={allIcons.find((st: any) => st.name === formik.values.icon) || null}
                          onChange={(option: any) => {
                            if (option && option.name !== "") {
                              formik.setFieldValue("icon", option.name);
                              handleValueChange({ target: { value: option.name } });
                            } else {
                              handleValueChange({ target: { value: null } });
                            }
                          }}
                          error={formik.touched.icon && Boolean(formik.errors.icon)}
                          helperText={formik.touched.icon && formik.errors.icon}
                        />
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={4} style={{ paddingLeft: "0px" }}>
                    <Box>
                      <TextField
                        className="customTextField"
                        required
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Add Vehicle Status"
                        name="name"
                        placeholder="Add Vehicle Status"
                        disabled={false}
                        value={formik.values.name}
                        onChange={handleValueChange}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={5} md={3} lg={2} style={{ padding: "8px 0" }}>
                    <Box>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={Boolean(formik.values.isOutOfWareHouse)}
                            onChange={formik.handleChange}
                            name="isOutOfWareHouse"
                            color="primary"
                          />
                        }
                        label="Checked-out"
                        style={{ marginRight: 0 }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={3} md={2}>
                    <Box>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(formik.values.isActive)}
                            onChange={formik.handleChange}
                            name="isActive"
                            color="primary"
                          />
                        }
                        label="Active"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4} md={12} lg={1} style={{ paddingRight: 0, float: "right" }}>
                    <Box mb={2} mt={1} style={{ float: "right" }}>
                      <CommonButton
                        isGreen
                        cssClass="customSubmitBtn"
                        disable={
                          selectedRecord
                            ? formik.values.name === selectedRecord.name &&
                              formik.values.icon === selectedRecord.icon &&
                              formik.values.isOutOfWareHouse === selectedRecord.isOutOfWareHouse &&
                              formik.values.isActive === selectedRecord.isActive
                            : JSON.stringify(formik.values) === JSON.stringify(formik.initialValues)
                        }
                        onClick={() => setSubmitCounter((prev: any) => prev + 1)}
                      >
                        {isEditMode ? "Update" : "Add"}
                      </CommonButton>
                    </Box>
                  </Grid>

                  <CommonMaterialGrid
                    defaultPerPageRecord={10}
                    height={400}
                    loader={false}
                    rows={tableRecord || []}
                    // rows={rows}
                    columns={displayColumns}
                  />
                </Grid>
                {/* End Inner Container */}
              </Grid>
              {/* End Outer Container */}
            </Grid>
          </>
        </Grid>
      </form>
    </>
  );
}
